import React from 'react';
import RoutesPage from './app/configuration/routes/Router';

function App() {
  return <RoutesPage />;
}

export default App;
